import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="item-matrix"
export default class extends Controller {
  static targets = ["input", "item", "checkbox", "empty", "visibleCount", "categoryCheckbox", "itemsContainer"]

  connect() {
    this.filter()
    this.update()
  }

  filter() {
    const query = this.hasInputTarget ? this.inputTarget.value.trim().toLowerCase() : ""
    let visibleCount = 0

    // Filter items
    this.itemTargets.forEach(item => {
      const name = item.dataset.name || ""
      const visible = query === "" || name.toLowerCase().includes(query)

      item.classList.toggle("hidden", !visible)
      if (visible) visibleCount += 1
    })

    // Auto expand containers if searching
    if (query !== "") {
      this.itemsContainerTargets.forEach(container => {
        container.classList.remove("hidden")
        const catName = container.dataset.category
        const btn = this.element.querySelector(`button[data-action="click->item-matrix#toggleCollapse"][data-category="${catName}"]`)
        if (btn) {
          const chevron = btn.querySelector("svg")
          if (chevron) chevron.style.transform = "rotate(0deg)"
        }
      })
    }

    if (this.hasEmptyTarget) this.emptyTarget.classList.toggle("hidden", visibleCount > 0)
    this.update()
  }

  selectAll(event) {
    event.preventDefault()
    this.checkboxTargets.forEach(checkbox => {
      if (this.visibleCheckbox(checkbox)) {
        checkbox.checked = true
      }
    })
    // Also check category checkboxes if they are visible
    this.categoryCheckboxTargets.forEach(catCb => {
      catCb.checked = true
    })
    this.update()
  }

  clearAll(event) {
    event.preventDefault()
    this.checkboxTargets.forEach(checkbox => {
      if (this.visibleCheckbox(checkbox)) {
        checkbox.checked = false
      }
    })
    // Also uncheck category checkboxes
    this.categoryCheckboxTargets.forEach(catCb => {
      catCb.checked = false
    })
    this.update()
  }

  toggle() {
    this.update()
  }

  toggleCategory(event) {
    const cb = event.currentTarget
    const catName = cb.dataset.category
    const isChecked = cb.checked

    // Set all child checkboxes to same state
    this.checkboxTargets
      .filter(c => c.dataset.category === catName)
      .forEach(c => {
        c.checked = isChecked
      })

    this.update()
  }

  toggleItem(event) {
    const cb = event.currentTarget
    const catName = cb.dataset.category

    // Update parent category checkbox
    const catCb = this.categoryCheckboxTargets.find(c => c.dataset.category === catName)
    if (catCb) {
      const children = this.checkboxTargets.filter(c => c.dataset.category === catName)
      const checkedChildren = children.filter(c => c.checked).length
      catCb.checked = checkedChildren === children.length
    }

    this.update()
  }

  toggleCollapse(event) {
    event.preventDefault()
    const btn = event.currentTarget
    const catName = btn.dataset.category
    const container = this.itemsContainerTargets.find(c => c.dataset.category === catName)

    if (container) {
      const isHidden = container.classList.toggle("hidden")
      const chevron = btn.querySelector("svg")
      if (chevron) {
        chevron.style.transform = isHidden ? "rotate(-90deg)" : "rotate(0deg)"
      }
    }
  }

  clearSearch(event) {
    event.preventDefault()
    if (this.hasInputTarget) this.inputTarget.value = ""
    this.filter()
    this.inputTarget.focus()
  }

  update() {
    const selectedCount = this.checkboxTargets.filter(checkbox => checkbox.checked).length
    const visibleCount = this.itemTargets.filter(item => !item.classList.contains("hidden")).length
    const totalCount = this.checkboxTargets.length

    const countEl = document.getElementById("selected-items-count")
    if (countEl) countEl.textContent = selectedCount

    const totalEl = document.getElementById("total-items-count")
    if (totalEl) totalEl.textContent = totalCount

    const summaryEl = document.getElementById("selected-items-summary")
    if (summaryEl) {
      summaryEl.textContent = selectedCount === totalCount ? "All items selected" : `${selectedCount} of ${totalCount} items selected`
    }

    if (this.hasVisibleCountTarget) this.visibleCountTarget.textContent = visibleCount

    // Update highlight styles for children items
    this.itemTargets.forEach(item => {
      const checkbox = item.querySelector("input[type='checkbox'][name*='item_names']")
      if (checkbox) {
        item.classList.toggle("border-brand-yellow", checkbox.checked)
        item.classList.toggle("bg-brand-yellow/10", checkbox.checked)
        item.classList.toggle("border-transparent", !checkbox.checked)
        item.classList.toggle("bg-white", !checkbox.checked)
      }
    })

    // Update highlight styles for parent categories
    this.categoryCheckboxTargets.forEach(catCb => {
      const catName = catCb.dataset.category
      const catRow = catCb.closest('[data-item-matrix-target="item"]')
      if (catRow) {
        catRow.classList.toggle("border-brand-yellow", catCb.checked)
        catRow.classList.toggle("bg-brand-yellow/10", catCb.checked)
        catRow.classList.toggle("border-slate-300", !catCb.checked)
        catRow.classList.toggle("bg-slate-50", !catCb.checked)
      }
    })
  }

  visibleCheckbox(checkbox) {
    const itemRow = checkbox.closest('[data-item-matrix-target="item"]')
    return itemRow && !itemRow.classList.contains("hidden")
  }
}
